 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		58: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + "." + {"0":"d94e2175baab7a6020de","1":"00978dcd8bc6eee268e3","2":"cc1e6e0e41c937f5c006","3":"e8c4413464ff9c370660","4":"0e971c74a6655ab7f1b5","5":"b8350b9c6daad039889b","6":"86b584476497893cfed7","7":"4b5b2e443bbcb6855ffd","8":"38b7f0bcdd9d7f97a46f","9":"6aaf16fac6088e86e197","10":"75bb85a2c374d8594dcd","11":"3cfc4b0b12f92c8ee00e","12":"94cb241855b27b943897","13":"859dcb4999dc6c61482b","14":"112d652f0e010db4a557","15":"4cf34b226b7b1fda8b67","16":"a0987cb0125f9e298960","17":"787d7bc3629532fb7b95","18":"b1bcf6c001568ed8443e","19":"0fc4bdd2adffe1941ad0","20":"ec478e6cadbe05bc75d5","21":"17b4b8a592fbe4ec1f2c","22":"0340ab10a922b8e21920","23":"d6f07f7029285cf66123","24":"a5897bfa01821bed02b0","25":"90db83991c19ac61b849","26":"68f788d9f72a9e816af7","27":"22c3cc5e7949c9cde61c","28":"6015e81e685bde3cfb3b","29":"4ccc13b2c2321cec8f8a","30":"01570ea6e28a363295e0","31":"5ec3016d9d7b61ecb5e8","32":"e89cb4d6a6cfbfd2039b","33":"9c10f3f59d1e5433cfd2","34":"6d033011d470c7534c06","35":"ec1c8fcd20aea836047c","36":"86ab9588ed88bfa007ac","37":"fdb966b2120034555bb2","38":"f4db671ff2251dcf8e8d","39":"f469bec3803e3d5a0425","40":"7e8193084a895a00d38c","43":"cec0e04fb0534ec425d3","44":"5ccee22add75fcd7a20a","45":"7663418a9e940870f2a2","46":"fa4ec722857004dce97d","47":"3c742b62e07d610eae96","48":"e1d2496f9ec466ccbef0","49":"1fbe3a1ca02cf7ceaaa8","50":"9f31ce38acb75057b2e1","51":"7c2d4b427826df4e2975","52":"7194677f1cb857092f5d","53":"0c646f787b11d7b95093","54":"b8fe796f0f34d2026070","55":"6fb68cd758605b15670b","56":"5aeba12d16c042b7aca3","57":"00fe7170255a2213d76b","60":"ee13c0aa0b17c8a17634","61":"f31edcc1d2665c6d22aa","62":"ad62922c634ea96361a2","63":"f38738766fab016c5597","64":"9cf2a81cd73d1fbd8004","65":"1ba8337dcdaf868c2c39","66":"75e4c7e44d234064ee2c","67":"13b570a42febc14158e2","68":"b4f86c2a9e13ccc4adbf","69":"3af5b7bd008c5e37526a","70":"7097ad109f651bbfba20","71":"0da4028337f31281ded8","72":"5a0c482a285e5d55fcc0","73":"00b02612ebf32e8c9cf9","74":"754c613c224e73836f5b","75":"31adfe3165aa1463bed3","76":"84e5d630f8045d016bf4","77":"12ab0ab00f0dbdbe1839","78":"44ec8928790b7aeff1e2","79":"3e8a4190c0ebc87aaac7","80":"230642123f098b7f60ff","81":"680f5b088e9957497e7e","82":"bc954148073af14fc255","83":"f950d33d1f28419cc225","84":"5135d531b1585534c4c0","85":"c3135b72067e91fd9df4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.catalog.staging.coursedog.com/14ad150/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
